import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { CustomerService } from "../customer/customer.service";
import { BatchstampService } from "../batchstamp/batchstamp.service";
import { LogsService } from "../../evs/logs/logs.service";

import { FormBuilder, NgForm } from "@angular/forms";
import { Subject, Subscription } from "rxjs/Rx";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Location } from "@angular/common";
import { EvsStampService } from "../../../../common/services/EvsStamp.service";
import { PagerService } from "../../../../common/services/Pagination.service";
import { ModalInfoService } from "../../../../common/services/ModalInfo.service";
import { EvsAddressService } from "../../../../common/services/EvsAddress.service";
import { ConfirmationService } from "primeng/primeng";
import { Message } from "primeng/components/common/message";
import { ToastrService } from "ngx-toastr";
import { BsModalService, ModalDirective } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import * as _ from "lodash";
import { ModalCancelStampComponent } from "../popup/modalCancelStamp.component";
import * as moment from "moment";
import { environment } from "../../../../../environments/environment";
import { ModalDistributionComponent } from "../popup/modalDistribution.component";
import { BatchService } from "../batchstamp/batch.service";
import { EvsProductService } from "../../../../common/services/EvsProduct.service";
import { IOption } from "../../../../../../node_modules/ng-select";
import { EvsStoreService } from "../../../../common/services/EvsStore.service";
import { ImageService } from "../../../imageService";
import { EvsUserService } from "../../../../common/services/EvsUser.service";
import { ExportFileService } from "../../../../shared/services/export-file.service";

declare var $: any;
declare var Chartist: any;

@Component({
  selector: "app-distribution",
  templateUrl: "./distribution.component.html",
  styleUrls: ["./distribution.component.css"],
  providers: [
    ConfirmationService,
    EvsAddressService,
    EvsStampService,
    BatchstampService,
    LogsService,
    EvsProductService,
    EvsStoreService,
    ImageService,
    EvsUserService,
    EvsUserService,
    ExportFileService,
  ],
})
export class DistributionComponent implements OnInit, OnDestroy {
  @ViewChild("lgModal") lgModal: ModalDirective;
  modalRef: BsModalRef;
  allLocation: BsModalRef;
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage: number = 1;
  public totalRow: number = 0;
  public page_size: number = 10;
  public offset: number = 0;
  public pager: any = {};
  public distributions: any = [];
  public message: { class: string; content: string } = null;
  public error: string = "";
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public paramsQuery: any = {};
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public msgs: Message[] = [];

  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;

  public arr_sort = { name: null };

  guarantees: any = [];
  guaranteeCurentpage: number = 1;
  public guaranteeTotalRow: number = 0;
  public guaranteePage_size: number = 10;
  public guaranteePager: any = {};

  isSorting: any = {};
  isUpdate: Boolean = false;

  itemDistricts: any;
  listItemDetailServices: any = [];

  public pieChartLabels: string[] = [];
  public pieChartData: number[] = [];
  public pieChartType: string = "pie";
  public pieChartOptions: any = {
    legend: {
      align: "center",
      position: "right",
    },
    responsive: true,
  };

  // events
  restoreModel: any = {};

  totalItem: any = 0;
  totalPage: any = 0;

  no_product = "assets/images/no_product.png";
  no_image = "assets/images/no-image.png";

  logDistribution: any = [];
  lat: number = 51.678418;
  lng: number = 7.809007;
  titleMap: any = "";
  zoom: number = 15;
  indexView: any;
  isShowLocation: Boolean = false;
  selectedCity: any;
  logFilter: any = {};

  logCurentpage: number = 1;
  logPage_size: number = 5;
  scanStatusLocation: any = [];
  colors: any = [
    {
      id: 1,
      color: "#061178",
    },
    {
      id: 2,
      color: "#926dde",
    },
    {
      id: 3,
      color: "#7dd3ae",
    },
    {
      id: 4,
      color: "#9bee48",
    },
    {
      id: 5,
      color: "#70726d",
    },
    {
      id: 6,
      color: "#df0f57",
    },
    {
      id: 7,
      color: "#317187",
    },
    {
      id: 8,
      color: "#d7cbb6",
    },
  ];
  isShowPie: Boolean = false;

  subcribe: Subscription = null;
  subcribe1: Subscription = null;
  bsModalRef: BsModalRef;
  listBatchs: Array<IOption> = [];
  listProducts: Array<IOption> = [];
  listStores: Array<IOption> = [];
  showMoreFilter: boolean = true;
  listStaff: any = [];
  /*Bien lay gia tri cua api export*/
  data_export;

  constructor(
    private _location: Location,
    private service: CustomerService,
    private pagerService: PagerService,
    private router: Router,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private mdInfo: ModalInfoService,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private evsStampService: EvsStampService,
    private batchstampService: BatchstampService,
    private modalService: BsModalService,
    private logsService: LogsService,
    private batchService: BatchService,
    private productService: EvsProductService,
    private storeService: EvsStoreService,
    private imageService: ImageService,
    private userService: EvsUserService,
    private exportFileService: ExportFileService
  ) {
    this.subcribe = this.modalService.onHide.subscribe((reason: string) => {
      this.currentPage = 0;
      this.current_filter = {};
      this.loadData(null, "desc");
    });
    this.item_detail = undefined;
  }

  ngOnInit() {
    var that = this;

    $("#timeFilter").datepicker({ format: "dd-mm-yyyy" });
    $("#inputStart").datepicker({ format: "dd-mm-yyyy" });
    $("#inputEnd").datepicker({ format: "dd-mm-yyyy" });
    $(".input-daterange").datepicker();

    //$('#store').select2({ placeholder: "-- Điểm bán/Điểm bảo hành --", allowClear: false });

    $("#product_id").select2({ placeholder: "Sản phẩm", allowClear: true });
    $("#staff_id").select2({
      placeholder: "Người phân phối",
      allowClear: true,
    });
    $("#batch_id").select2({ placeholder: "Lô tem", allowClear: true });
    $("#store_id").select2({
      placeholder: "Cửa hàng",
      allowClear: true,
      ajax: {
        url: environment.api_evs + "/g_store?limit=50",
        headers: {
          authorization: localStorage.getItem("Access-Token"),
        },
        dataType: "json",
        data: function (params) {
          var query: any = {
            desc: "created_at",
          };
          if (params.term) query.name = params.term;
          return query;
        },
        processResults: function (data) {
          // Tranforms the top-level key of the response object from 'items' to 'results'
          let stores = data.data.store;
          let listStores: any = [];
          for (let i = 0; i < stores.length; i++) {
            let item = {
              id: stores[i].id.toString(),
              text: stores[i].name,
            };
            listStores.push(item);
          }
          this.listStores = listStores;
          return {
            results: this.listStores,
          };
        },
      },
    });
    $("#province").select2({ placeholder: "Tỉnh/TP", allowClear: true });
    $("#district").select2({ placeholder: "Quận/Huyện", allowClear: true });
    $("#province").on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      var id = e.target.value;
      that.loadDistrictData(id);
    });
    $("#province").on("select2:unselect", function (e) {
      that.districts = [];
      $("#district").val("").trigger("change");
    });
    $("#district").on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
    });
    // this.clearDataForm();
    this.getCity();
    // this.getListProduct();
    this.getListBatches();
    this.getStaffList();
    //this.getListStore();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = "desc";
      if (params.batch_id) {
        this.current_filter.batch_id = params.batch_id;
        $("#batch_id").val(params.batch_id).trigger("change");
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });

    //this.loadData();
  }

  ngOnDestroy() {
    if (this.subcribe) this.subcribe.unsubscribe();
    if (this.subcribe1) this.subcribe1.unsubscribe();
  }
  getStaffList() {
    this.userService
      .getEmployees({ desc: "id" })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.listStaff = res.data.staffs;
          let listStaff: any = [];
          let master: any = res.data.master;
          if (master) {
            listStaff.push({
              id: master.id,
              name: master.name,
            });
          }
          for (let i = 0; i < this.listStaff.length; i++) {
            listStaff.push({
              id: this.listStaff[i].id,
              name: this.listStaff[i].name,
            });
          }
          this.listStaff = listStaff;
        }
      });
  }
  getListStore() {
    let opt: any = {
      limit: 500,
    };
    this.storeService.getAll(opt).subscribe((res) => {
      if (!res.error) {
        let stores = res.data.store;
        let listStores: any = [];
        for (let i = 0; i < stores.length; i++) {
          let item = {
            value: stores[i].id.toString(),
            label: stores[i].name,
          };
          listStores.push(item);
        }
        this.listStores = listStores;
      }
    });
  }
  // getListProduct() {
  //   let opt: any = {
  //     limit: 500
  //   };
  //   this.productService.getProducts(opt).subscribe(res => {
  //     if (!res.error) {
  //       let products = res.data.products;
  //       let listProducts: any = [];
  //       for (let i = 0; i < products.length; i++) {
  //         let item = {
  //           value: products[i].id.toString(),
  //           label: products[i].name
  //         };
  //         listProducts.push(item);
  //       }
  //       this.listProducts = listProducts;
  //     }
  //   });
  // }
  getListBatches() {
    let opt: any = {
      limit: 500,
      service: 3,
      show_child: 1,
    };
    this.batchService.getBatchesList(opt).subscribe((res) => {
      if (!res.error) {
        let batchs = res.data.batches;
        let listBatchs: any = [];
        for (let i = 0; i < batchs.length; i++) {
          let item = {
            value: batchs[i].id.toString(),
            label: batchs[i].name,
          };
          listBatchs.push(item);
        }
        this.listBatchs = listBatchs;
      }
    });
  }
  loadGuarantee() {
    var request = {};
    request["offset"] =
      this.guaranteePage_size *
      (this.guaranteeCurentpage <= 0 ? 0 : this.guaranteeCurentpage - 1);
    request["limit"] = this.guaranteePage_size;
    request["desc"] = "created_time";

    if (this.item_detail.name) {
      request["customer_name"] = this.item_detail.name;
      this.evsStampService.getLogGuarantee(request).subscribe((data) => {
        //console.log(data.data.logs)
        this.guarantees = data.data.logs;
      });
    }
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.id,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  loadDistrictDataItemDetail(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.itemDistricts = districts;
        if (this.item_detail) {
          for (let i = 0; i < this.itemDistricts.length; i++) {
            if (this.item_detail.district == this.itemDistricts[i].id) {
              this.item_detail.district = this.itemDistricts[i].value;
            }
          }
        }
      });
  }

  loadData(request: any = {}, sort: string = "desc") {
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }

    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    request.deleted = 0;
    request.sort_by = "created_time:" + sort;
    this.batchstampService
      .getDistribution(request)
      .toPromise()
      .then(
        (res) => {
          this.loading_data = false;
          let error = res.error;
          if (res.status == 200 && res.error == false) {
            if (res.data.logs) {
              this.distributions = res.data.logs;

              this.totalItem = res.data.total;
              var pageString = (this.totalItem / this.page_size).toString();
              var pageSplit = pageString.split(".");
              var last: any;
              var totalpage = parseInt(pageSplit[0]);
              if (pageSplit.length > 1) {
                last = pageSplit[1];
                if (parseInt(last) > 0) {
                  totalpage++;
                }
              }
              this.totalPage = totalpage;
              for (let i = 0; i < this.distributions.length; i++) {
                if (
                  this.distributions[i].prefix &&
                  this.distributions[i].id_start &&
                  this.distributions[i].id_end
                ) {
                  this.distributions[i].serial = this.formatSerial(
                    this.distributions[i].id_start,
                    this.distributions[i].id_end,
                    this.distributions[i].prefix
                  );
                }
                if (this.distributions[i].product) {
                  this.distributions[
                    i
                  ].product.image = this.imageService.readSrcImage(
                    this.distributions[i].product.image,
                    "thumb_medium"
                  );
                }
                var stamp_services: any = [];
                if (this.distributions[i].batch) {
                  var services = this.distributions[i].batch.services;
                  var listServices = services.split(",");
                  for (let h = 0; h < listServices.length; h++) {
                    switch (listServices[h]) {
                      case "1": {
                        stamp_services.push({
                          id: 1,
                          name: "Chống giả",
                        });
                        break;
                      }
                      case "2": {
                        stamp_services.push({
                          id: 2,
                          name: "Bảo hành",
                        });
                        break;
                      }
                      case "3": {
                        stamp_services.push({
                          id: 3,
                          name: "Tràn hàng",
                        });
                        break;
                      }
                    }
                  }
                }
                this.distributions[i]["services"] = stamp_services;
              }

              if (this.distributions.length > 0) {
                this.viewDetail(
                  this.item_active,
                  this.distributions[this.item_active]
                );
              } else {
                this.item_active = 0;
                this.item_detail = null;
              }
            }
          }
        },
        (err) => {}
      );
  }

  viewDetail(i, item) {
    this.listItemDetailServices = [];
    this.scanStatusLocation = [];
    this.isUpdate = false;
    this.item_active = i;
    this.batchstampService.getDistributionDetail(item._id).subscribe((res) => {
      this.item_detail = res.data;
      if (this.item_detail) {
        this.item_detail.serial = this.formatSerial(
          this.item_detail.id_start,
          this.item_detail.id_end,
          this.item_detail.prefix
        );
        if (this.item_detail.product) {
          this.item_detail.product.image = this.imageService.readSrcImage(
            this.item_detail.product.image,
            "thumb_medium"
          );
        }
        if (this.item_detail.scan_location) {
          if (this.item_detail.scan_location.length > 0) {
            this.scanStatusLocation = this.item_detail.scan_location;
            if (this.scanStatusLocation.length > 6) {
              this.scanStatusLocation.splice(
                6,
                this.scanStatusLocation.length - 6
              );
            }
            this.pieChartData = [];
            this.pieChartLabels = [];

            for (let i = 0; i < 6; i++) {
              for (let j = 0; j < this.colors.length; j++) {
                if (this.colors[j])
                  if (i + 1 == this.colors[j].id) {
                    if (this.scanStatusLocation[i]) {
                      this.scanStatusLocation[i]["color"] = this.colors[
                        j
                      ].color;
                      this.pieChartData.push(this.scanStatusLocation[i].hits);
                    }
                  }
              }
            }
            var dataPie = {
              series: this.pieChartData,
            };
            var options = {
              labelInterpolationFnc: function (value) {
                if (value) return value[0];
              },
            };
            if (
              $("#scanWithLocation").length > 0 &&
              this.scanStatusLocation.length > 0
            ) {
              this.isShowPie = true;
              new Chartist.Pie("#scanWithLocation", dataPie, options);
            }
          } else this.isShowPie = false;
        }
        if (this.item_detail.location.length > 0) {
          for (let i = 0; i < this.item_detail.location.length; i++) {
            this.item_detail.location[i].lat = parseFloat(
              this.item_detail.location[i].lat
            );
            this.item_detail.location[i].lon = parseFloat(
              this.item_detail.location[i].lon
            );
          }
        }
      } else {
        this.item_detail = null;
      }
    });
  }

  onSubmit() {
    this.item_active = 0;
    this.getData();
  }

  productId: any = null;
  changeProduct(event) {
    this.productId = event ? event : null;
  }

  getData() {
    let modelQuery = <any>{};
    if ($("#serial").val()) {
      modelQuery.serial = $("#serial").val();
    }
    if ($("#batch_id").val()) {
      modelQuery.batch_id = $("#batch_id").val();
    }
    if (this.productId) {
      modelQuery.product_id = this.productId;
    }
    if ($("#store_id").val()) {
      modelQuery.store_id = $("#store_id").val();
    }
    if ($("#staff_id").val()) {
      modelQuery.user_created = $("#staff_id").val();
    }
    if ($("#province").val()) {
      modelQuery.city = [];
      modelQuery.city.push($("#province").val());
    }
    if ($("#district").val()) {
      modelQuery.district = [];
      modelQuery.district.push($("#district").val());
    }
    if ($("#created_time").val()) {
      let date = $("#created_time").val();
      let listDate = date.toString().split(" - ");
      if (listDate.length > 1) {
        modelQuery.from = moment(listDate[0], ["DD/MM/YYYY"])["_d"];
        modelQuery.to = moment(listDate[1], ["DD/MM/YYYY"])["_d"];
      }
    }

    this.currentPage = 1;
    this.current_filter = modelQuery;
    this.loadData(modelQuery, this.isSorting);
  }

  resetForm(frm: NgForm) {
    $("#product_id").val("").trigger("change");
    $("#batch_id").val("").trigger("change");
    $("#store_id").val("").trigger("change");
    $("#staff_id").val("").trigger("change");
    $("#province").val("").trigger("change");
    $("#district").val("").trigger("change");
    this.districts = [];
    frm.reset();
    this.getData();
  }

  /* pagination */
  setPage(page: number) {
    this.item_active = 0;
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.isSorting);
      }
    } else {
      page = this.totalPage;
      $("#inputPage").val(page);
      this.toastr.warning("Số trang tối đa hiện tại là " + page, "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.isSorting);
      }
    }
  }

  setGuaranteePage(page: number) {
    this.guaranteePager = this.pagerService.getPager(
      this.guaranteeTotalRow,
      this.guaranteeCurentpage,
      this.guaranteePage_size
    );
    if (page < 1) {
      page = 1;
    }
    if (page != this.guaranteeCurentpage) {
      this.guaranteeCurentpage = page;
      this.loadGuarantee();
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return this.page_size * (this.currentPage - 1) + (i + 1); //currentPage start from: 0
    }
  }

  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery, this.isSorting);
    }
  }

  backToComponent() {
    this._location.back();
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  goGuaranteePage2(toPage: number) {
    //console.log(toPage);
    if (!toPage) {
      toPage = 1;
    }
    if (toPage && toPage > 0) {
      this.setGuaranteePage(toPage);
    }
  }

  setSort(typeSort: string) {
    this.currentPage = 1;
    this.isSorting = typeSort;
    this.loadData(null, typeSort);
  }

  backUpdateWork(event) {
    this.isUpdate = false;
    if ((event.isBack = false)) {
      this.loadData(null, this.isSorting);
    }
  }

  showReStore(template: TemplateRef<any>) {
    // this.modalRef = this.modalService.show(template);
    var res = this.item_detail;
    let detail = {
      //name: res.data.name,
      id: res.batch.id,
      name: res.batch.name,
      id_start: res.id_start,
      id_end: res.id_end,
      prefix: res.prefix,
      readonly: true,
    };
    const initialState = { batch_detail: detail };
    this.modalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.modalRef.content.closeBtnName = "Bỏ qua";
  }

  formatSerial(id_start, id_end, prefix) {
    let serial: string = "";
    id_end = id_end.toString();
    id_start = id_start.toString();
    if (id_end && id_start && prefix) {
      let pad = "000000";
      let serial_start = pad.substring(0, 6 - id_start.length) + id_start;
      let serial_end = pad.substring(0, 6 - id_end.length) + id_end;
      serial =
        prefix + "-" + serial_start + " đến " + prefix + "-" + serial_end;
    }
    return serial;
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  loadDataDetail() {
    if (!this.subcribe1) {
      this.subcribe1 = this.lgModal.onHide.subscribe(() => {
        this.logCurentpage = 1;
      });
    }
    var request: any = {
      service: 3,
      batch_id: this.item_detail.batch_id,
      id_start: this.item_detail.id_start,
      id_end: this.item_detail.id_end,
    };
    // if ($('#timeFilter').val()) {
    //   request.ins_dt = $('#timeFilter').val();
    // }
    if (this.logFilter.time && this.logFilter.time.length > 1) {
      request.from = moment(this.logFilter.time[0]).format("YYYY-MM-DD");
      request.to = moment(this.logFilter.time[1]).format("YYYY-MM-DD");
    }
    if (this.logFilter.city) {
      request.city_id = this.logFilter.city;
    }

    request.offset =
      this.logPage_size *
      (this.logCurentpage <= 0 ? 0 : this.logCurentpage - 1);
    request.limit = this.logPage_size;
    request.sort_by = "ins_dt:desc";
    this.logsService.getLogsScan(request).subscribe((res) => {
      if (!res.error) {
        this.logDistribution = res.data;
        for (let i = 0; i < this.logDistribution.length; i++) {
          if (
            this.logDistribution[i].number &&
            this.logDistribution[i].prefix
          ) {
            let pad = "000000";
            let serial_number =
              pad.substring(
                0,
                6 - this.logDistribution[i].number.toString().length
              ) + this.logDistribution[i].number;
            var serial = this.logDistribution[i].prefix + "-" + serial_number;
            this.logDistribution[i].serial = serial;
          }
        }
      }
    });
  }

  showLocation(template: TemplateRef<any>, data: any, index: any) {
    this.indexView = index;
    this.lat = 51.678418;
    this.lng = 7.809007;
    if (data.lat && data.lon) {
      this.isShowLocation = true;
      this.lat = parseFloat(data.lat);
      this.lng = parseFloat(data.lon);
    } else {
      this.lat = 51.678418;
      this.lng = 7.809007;
      this.isShowLocation = false;
    }
    if (data.number && data.prefix) {
      let pad = "000000";
      let serial_number =
        pad.substring(0, 6 - data.number.toString().length) + data.number;
      var serial = data.prefix + "-" + serial_number;
      this.titleMap = "Vị trí kiểm tra phân phối: (" + serial + ")";
    }
    this.modalRef = this.modalService.show(template, { class: "second" });
    this.subcribe = this.modalService.onHide.subscribe((reason: string) => {
      this.indexView = null;
    });
  }

  resetFilter() {
    this.logFilter = {};
    $("#timeFilter").val(null);
    this.loadDataDetail();
  }

  setLogPage(page: number) {
    if (page < 1) {
      this.logCurentpage = 1;
      return;
    }
    // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
    if (page !== this.logCurentpage) {
      this.logCurentpage = page;
      this.loadDataDetail();
    }
  }

  goLogPage(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setLogPage(toPage);
    } else {
      this.setLogPage(1); //toPage = 1;
    }
  }

  showPopupDistribution() {
    this.bsModalRef = this.modalService.show(ModalDistributionComponent, {});
    this.bsModalRef.content.closeBtnName = "Bỏ qua";
  }

  downloadExcel() {
    let modelQuery = <any>{};
    if ($("#serial").val()) {
      modelQuery.serial = $("#serial").val();
    }
    if ($("#batch_id").val()) {
      modelQuery.batch_id = $("#batch_id").val();
    }
    if ($("#product_id").val()) {
      modelQuery.product_id = $("#product_id").val();
    }
    if ($("#store_id").val()) {
      modelQuery.store_id = $("#store_id").val();
    }
    if ($("#staff_id").val()) {
      modelQuery.user_created = $("#staff_id").val();
    }
    if ($("#province").val()) {
      modelQuery.city = [];
      modelQuery.city.push($("#province").val());
    }
    if ($("#district").val()) {
      modelQuery.district = [];
      modelQuery.district.push($("#district").val());
    }
    if ($("#created_time").val()) {
      let date = $("#created_time").val();
      let listDate = date.toString().split(" - ");
      if (listDate.length > 1) {
        modelQuery.from = moment(listDate[0], ["DD/MM/YYYY"])["_d"];
        modelQuery.to = moment(listDate[1], ["DD/MM/YYYY"])["_d"];
      }
    }

    // var url = environment.api_evs + "/distribution/excel?";
    var url = "/distribution/excel?";

    if (modelQuery.serial) url += "serial=" + modelQuery.serial;
    if (modelQuery.batch_id) url += "&batch_id=" + modelQuery.batch_id;
    if (modelQuery.product_id) url += "&product_id=" + modelQuery.product_id;
    if (modelQuery.store_id) url += "&store_id=" + modelQuery.store_id;
    if (modelQuery.user_created)
      url += "&user_created=" + modelQuery.user_created;
    if (modelQuery.from) url += "&from=" + modelQuery.from;
    if (modelQuery.to) url += "&to=" + modelQuery.to;
    if (modelQuery.city) url += "&city=" + modelQuery.city;
    if (modelQuery.district) url += "&district=" + modelQuery.district;
    url += "&sort_by=created_time:" + this.isSorting;
    if (localStorage.getItem("Access-Token")) {
      url += "&Access_Token=" + localStorage.getItem("Access-Token");
    }
    url += "&is_excel=1";
    // location.href = url;
    // console.log(url);
    this.exportFileService.callApiExport(url).subscribe(
      (err) => {
        console.log(err);
        this.data_export = err;
      },
      (res) => {
        console.log(res);
        this.data_export = res;
      }
    );
  }

  showAllLocation(template) {
    this.allLocation = this.modalService.show(template);
  }

  updateInfo() {
    this.router.navigate([`/evs/business/profile`]);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution/distribution.component.ts